import { BankIdEventTypeV1 } from '../../../../../../../api/generated/cz.partners.pid.backofficegateway.pidbankid.external';

export const ALL_BANK_ID_EVENT_TYPES_CHOSEN = {
	ALL_BANK_ID_EVENT_TYPES_CHOSEN: 'ALL_BANK_ID_EVENT_TYPES_CHOSEN',
} as const;

export type ExtendedBankIdEventType =
	| BankIdEventTypeV1
	| (typeof ALL_BANK_ID_EVENT_TYPES_CHOSEN)[keyof typeof ALL_BANK_ID_EVENT_TYPES_CHOSEN];

export const ExtendedBankIdEventType = {
	...BankIdEventTypeV1,
	...ALL_BANK_ID_EVENT_TYPES_CHOSEN,
} as const;
